import React, { useEffect, useState } from 'react';
import Group from '../../../components/form/elements/group';
import Form from '../../../components/form';
import { useParams } from 'react-router-dom';
import { useService } from '../../../services/services';
import Text from '../../../components/form/elements/text';
import Checkbox from '../../../components/form/elements/checkbox';
import User from '../../../interfaces/user';
import Readonly from '../../../components/form/elements/readonly';
import Link from '../../../components/form/elements/link';
import {
  INTERNAL_USERS_EDIT,
  INTERNAL_USERS_INDEX,
} from '../../../router/routes';
import { route } from '../../../services/utils';
import { useObservableState } from 'observable-hooks';
import { map } from 'rxjs/operators';

export default function ViewUser() {
  const { id } = useParams<{ id: string }>();
  const { userService } = useService();
  const [bodyElements, setBodyElements] = useState([]);
  const [footerElements, setFooterElements] = useState([]);

  const [user] = useObservableState<User>(
    () =>
      userService.show(id).pipe(
        map((user: User) => {
          const mappedUser = { ...user, roles: {} as any };

          user.roles.forEach((role: string) => {
            mappedUser.roles[role] = true;
          });

          return mappedUser;
        })
      ),
    null
  );

  useEffect(() => {
    if (user !== null) {
      const roleElements = Object.keys(user.roles).map((role: string) => {
        return Checkbox(`roles.${role}`, role);
      });

      setBodyElements([
        Readonly([
          Group([
            Text('username'),
            Text('name'),
            Text('email'),
            Checkbox('blocked'),
            ...roleElements,
          ]),
        ]),
      ]);

      setFooterElements([
        Link(route(INTERNAL_USERS_EDIT, { id: user.id }), 'edit', true),
      ]);
    }
  }, [id, userService, setBodyElements, setFooterElements, user]);

  return (
    <Form
      title={user ? user.username : null}
      backTo={INTERNAL_USERS_INDEX}
      mode={'view'}
      body={bodyElements}
      footer={footerElements}
      values={user}
      noticeAccessor="ViewForm"
    />
  );
}
